/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { EvaluationParameterDto } from './EvaluationParameterDto';
import {
    EvaluationParameterDtoFromJSON,
    EvaluationParameterDtoFromJSONTyped,
    EvaluationParameterDtoToJSON,
} from './EvaluationParameterDto';
import type { WorkState } from './WorkState';
import {
    WorkStateFromJSON,
    WorkStateFromJSONTyped,
    WorkStateToJSON,
} from './WorkState';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { TrackItTaskWorkResultDto } from './TrackItTaskWorkResultDto';
import {
    TrackItTaskWorkResultDtoFromJSON,
    TrackItTaskWorkResultDtoFromJSONTyped,
    TrackItTaskWorkResultDtoToJSON,
} from './TrackItTaskWorkResultDto';
import type { ParameterCombinationDto } from './ParameterCombinationDto';
import {
    ParameterCombinationDtoFromJSON,
    ParameterCombinationDtoFromJSONTyped,
    ParameterCombinationDtoToJSON,
} from './ParameterCombinationDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface TrackItTaskWorkStepDto
 */
export interface TrackItTaskWorkStepDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkStepDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkStepDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItTaskWorkStepDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkStepDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItTaskWorkStepDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {ParameterCombinationDto}
     * @memberof TrackItTaskWorkStepDto
     */
    combination?: ParameterCombinationDto;
    /**
     * 
     * @type {Array<EvaluationParameterDto>}
     * @memberof TrackItTaskWorkStepDto
     */
    evaluations?: Array<EvaluationParameterDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrackItTaskWorkStepDto
     */
    isExecutable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkStepDto
     */
    workStepPreviewId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackItTaskWorkStepDto
     */
    evaluationIds?: Array<string> | null;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof TrackItTaskWorkStepDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {WorkState}
     * @memberof TrackItTaskWorkStepDto
     */
    workState?: WorkState;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof TrackItTaskWorkStepDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkStepDto
     */
    commentEntityCompositeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItTaskWorkStepDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkStepDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItTaskWorkStepDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof TrackItTaskWorkStepDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof TrackItTaskWorkStepDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {Array<TrackItTaskWorkResultDto>}
     * @memberof TrackItTaskWorkStepDto
     */
    results?: Array<TrackItTaskWorkResultDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkStepDto
     */
    $type?: TrackItTaskWorkStepDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItTaskWorkStepDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoTrackItTaskWorkStepDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.TrackItTaskWorkStepDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItTaskWorkStepDtoTypeEnum = typeof TrackItTaskWorkStepDtoTypeEnum[keyof typeof TrackItTaskWorkStepDtoTypeEnum];



/**
 * Check if a given object implements the TrackItTaskWorkStepDto interface.
 */
export function instanceOfTrackItTaskWorkStepDto(value?: unknown): value is TrackItTaskWorkStepDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItTaskWorkStepDtoTypeEnum)[0];
}

export function TrackItTaskWorkStepDtoFromJSON(json: any): TrackItTaskWorkStepDto {
    return TrackItTaskWorkStepDtoFromJSONTyped(json, false);
}

export function TrackItTaskWorkStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItTaskWorkStepDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'combination': json['combination'] == null ? undefined : ParameterCombinationDtoFromJSON(json['combination']),
        'evaluations': json['evaluations'] == null ? undefined : ((json['evaluations'] as Array<any>).map(EvaluationParameterDtoFromJSON)),
        'isExecutable': json['isExecutable'] == null ? undefined : json['isExecutable'],
        'workStepPreviewId': json['workStepPreviewId'] == null ? undefined : json['workStepPreviewId'],
        'evaluationIds': json['evaluationIds'] == null ? undefined : json['evaluationIds'],
        'taskType': json['taskType'] == null ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'workState': json['workState'] == null ? undefined : WorkStateFromJSON(json['workState']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'commentEntityCompositeId': json['commentEntityCompositeId'] == null ? undefined : json['commentEntityCompositeId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(TrackItTaskWorkResultDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItTaskWorkStepDtoToJSON(value?: Omit<TrackItTaskWorkStepDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'combination': ParameterCombinationDtoToJSON(value['combination']),
        'evaluations': value['evaluations'] == null ? undefined : ((value['evaluations'] as Array<any>).map(EvaluationParameterDtoToJSON)),
        'isExecutable': value['isExecutable'],
        'workStepPreviewId': value['workStepPreviewId'],
        'evaluationIds': value['evaluationIds'],
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        'workState': WorkStateToJSON(value['workState']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'commentEntityCompositeId': value['commentEntityCompositeId'],
        'commentCount': value['commentCount'],
        'lastComment': value['lastComment'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(TrackItTaskWorkResultDtoToJSON)),
        '$type': value['$type'],
    });
}

